export const bookings_events = {
  // "Partner portal events" tracking sheet → Bookings page, Tier 1. Labels are
  // the sheet's event names verbatim.
  bookings_table_select_click: {
    category: 'Bookings page (Booking)',
    action: 'Booking row click',
    label: 'bookings-table-select-click',
  },
  bookings_detail_nav_print_click: {
    category: 'Bookings page (Booking)',
    action: 'Booking detail Print click',
    label: 'bookings-detail-nav-print-click',
  },
  bookings_detail_nav_download_click: {
    category: 'Bookings page (Booking)',
    action: 'Booking detail Download click',
    label: 'bookings-detail-nav-download-click',
  },
  bookings_detail_nav_actions_click: {
    category: 'Bookings page (Booking)',
    action: 'Booking detail Actions click',
    label: 'bookings-detail-nav-actions-click',
  },
  bookings_detail_nav_actions_update: {
    category: 'Bookings page (Booking)',
    action: 'Actions → Update Booking',
    label: 'bookings-detail-nav-actions-update',
  },
  bookings_detail_nav_actions_void: {
    category: 'Bookings page (Booking)',
    action: 'Actions → Void Tickets',
    label: 'bookings-detail-nav-actions-void',
  },
  bookings_detail_nav_actions_resend: {
    category: 'Bookings page (Booking)',
    action: 'Actions → Resend Documents',
    label: 'bookings-detail-nav-actions-resend',
  },

  partner_booking_edit_save: {
    category: 'Partner bookings',
    action: 'Operator saves edits to a booking',
    label: 'partner_booking_edit_save',
  },
  partner_booking_documents_sent: {
    category: 'Partner bookings',
    action: 'Operator resends booking documents',
    label: 'partner_booking_documents_sent',
  },
  partner_booking_modify_complete: {
    category: 'Partner booking servicing',
    action: 'A booking modification completes',
    label: 'partner_booking_modify_complete',
  },
  partner_booking_cancel_complete: {
    category: 'Partner booking servicing',
    action: 'A booking cancellation completes',
    label: 'partner_booking_cancel_complete',
  },
  partner_booking_request_sent: {
    category: 'Partner booking servicing',
    action: 'A manual modify or cancel request is sent',
    label: 'partner_booking_request_sent',
  },
  partner_manual_booking_success: {
    category: 'Partner manual bookings',
    action: 'Operator creates a manual booking',
    label: 'partner_manual_booking_success',
  },
  partner_manual_booking_failure: {
    category: 'Partner manual bookings',
    action: 'A manual booking is refused',
    label: 'partner_manual_booking_failure',
  },
  partner_travel_booking_complete: {
    category: 'Partner travel',
    action: 'A booking completes in the embedded travel app',
    label: 'partner_travel_booking_complete',
  },
};
